/** Height of the taskbar in CSS pixels. Must match `Taskbar.module.css`. */
export const TASKBAR_H = 30;

/**
 * Title bar height. xp.css 0.2.6 ships 21px, which is noticeably shorter than
 * the real thing; `Window.module.css` overrides it to 28px via `--xp-title-h`.
 * Keep this number, that CSS variable, and the drag clamp in agreement.
 */
export const TITLE_H = 28;

/** How much of a window must stay on-screen horizontally when dragged off. */
export const MIN_VISIBLE = 90;

/** Offset between cascaded windows. */
export const CASCADE_STEP = 24;

/** How many steps before the cascade wraps back to the origin. */
export const CASCADE_WRAP = 10;

/** Where the first cascaded window lands. */
export const CASCADE_ORIGIN = { x: 40, y: 24 };

/** Fallback minimum window size when a manifest doesn't specify one. */
export const DEFAULT_MIN_SIZE = { w: 240, h: 140 };

/** Thickness of the edge resize handles. */
export const RESIZE_EDGE = 6;

/** Size of the square corner resize handles. */
export const RESIZE_CORNER = 14;

/**
 * Class a chromeless window's own caption must carry to be draggable.
 *
 * A window with no title bar has no obvious grab area, and making the whole
 * frame draggable would swallow clicks on the app inside it. So a chromeless
 * app marks its own caption strip with this, and `useDrag` starts a drag only
 * from there.
 */
export const DRAG_HANDLE = 'wm-drag-handle';

/** z-index floor for windows; the taskbar and shell chrome sit above this. */
export const Z_BASE = 100;
